export default __webpack_public_path__ + "static/commercial-logo-bd1cf48825c887281c621c84ba6f93a3.png";